import { useCallback, useEffect, useRef } from "react";
export function useDebounceWithReset(callback, delay = 750) {
    const timeoutRef = useRef(null);
    const callbackRef = useRef(callback);
    useEffect(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    useEffect(()=>{
        return ()=>{
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    const debouncedFunction = useCallback((...args)=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(()=>{
            callbackRef.current(...args);
        }, delay);
    }, [
        delay
    ]);
    return debouncedFunction;
}

//# sourceMappingURL=useDebounceWithReset.js.map